import {registerRoute as workbox_routing_registerRoute} from '/Users/shaneg/dev/app3/builds/apic-common/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/Users/shaneg/dev/app3/builds/apic-common/node_modules/workbox-strategies/NetworkFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/Users/shaneg/dev/app3/builds/apic-common/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/shaneg/dev/app3/builds/apic-common/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/shaneg/dev/app3/builds/apic-common/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/cdn/apic-common/js/@dojo/loader/loader.js",
    "revision": "f66a38c73e036053cd0d1f928cb24e38"
  },
  {
    "url": "/cdn/apic-common/js/core-js/polyfill.js",
    "revision": "149d609e92b0f722f6318e724ee932bd"
  },
  {
    "url": "/cdn/apic-common/js/main.457292040af9f866e9ce.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-CN_Calendar_mjs.f6a8ea21ef4f150c8784.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_dojo_widgets_calendar_nls_zh-TW_Calendar_mjs.84b128945a625110673d.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-CN_Dialog_mjs.d47b3291e61a487a1add.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_dojo_widgets_dialog_nls_zh-TW_Dialog_mjs.5bf6cb7d0ca7e0caaae1.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_fr-CA_DateInput_js.5f878a3a890847586345.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-CN_DateInput_js.d1a3372a5ca156e1adf9.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_base-widgets_date-input_nls_zh-TW_DateInput_js.942eb00ffdf4c32f6e66.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-CN_index_js.05953ead418a0b330d12.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_base-widgets_sliding-pane_nls_zh-TW_index_js.c68d2cf88cc6a48feb9a.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-CN_index_js.b57a7c79e8592d068eb3.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_base-widgets_tab-container_nls_zh-TW_index_js.d8d01d3f95fca379d06d.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/packages_node_modules_holmescorp_search-widget_main_js.993cb6a23097d5cf7b9f.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/vendors-packages_node_modules_holmescorp_ask-the-instructor_main_js.d982311955b73a06416d.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/vendors-packages_node_modules_holmescorp_class-roster_main_js.70f133175e1245669c23.js",
    "revision": null
  },
  {
    "url": "/cdn/apic-common/js/vendors-packages_node_modules_holmescorp_editor-widget_index_js.0adeed6713bc3477b711.js",
    "revision": null
  }
], {});




workbox_routing_registerRoute(/.+\/$/, new workbox_strategies_NetworkFirst({ "cacheName":"apic-common-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\/js\/sitestart\.js$/, new workbox_strategies_NetworkFirst({ "cacheName":"apic-common-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.(?:jpg|jpeg|png|svg|ttf|woff|woff2|eot|ico)$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"apic-common-site", plugins: [] }), 'GET');
workbox_routing_registerRoute(/.+\.css$/, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"apic-common-site", plugins: [] }), 'GET');




